export default {
    default: {
        tracesSampleRate: 0.1,
        tracingOptions: {
            hooks: ['mount'],
            trackComponents: true
        },
        ignoreErrors: [
            'top.GLOBALS',
            'canvas.contentDocument',
            'Script error.',
            'Non-Error promise rejection captured with value: Timeout',
            'Timeout',
            'Unhandled error.',
            'ResizeObserver loop limit exceeded',
            'DOM Exception 12: An invalid or illegal string was specified.',
            'Non-Error exception captured with keys',
            'Non-Error promise rejection captured with keys',
            'ReportingObserver [deprecation]',
            'An unknown error occurred',
            '<unknown>',
            'SecurityError',
            // 接口超时错误
            'timeout of 0ms exceeded',
            // 网络错误
            'Network Error',
            // iOS 音视频播放问题
            'The operation was aborted',
            'The operation is not supported',
            'The request is not allowed by the user agent',
            'The play() request was interrupted',
            // 微信JSSDK
            '找不到对应的安全域名',
            // APP
            'n.success is not a function',
            'Unexpected identifier',
            'Unexpected end of input',
            'Unexpected EOF',
            'Unexpected token ILLEGAL',
            'Invalid or unexpected token',
            'window.Mama.preloadPageShow() is not a function',
            // 外部错误
            /sogou/gi
        ],
        allowUrls: ['mama.cn', 'cdnmama.com', 'www.mamagoods.cn'],
        maxBreadcrumbs: 30,
        autoSessionTracking: true
    },
    BrowserTracing: {
        tracingOrigins: ['localhost'], // 不再在请求头
        idleTimeout: 500,
        maxTransactionDuration: 15,
        _metricOptions: {
            _reportAllChanges: true
        }
    },
    SystemSupport: {
        android: 5,
        ios: 9
    }
};
